export default __webpack_public_path__ + "static/media/icon-highlight-traction.92305b7f.svg";